import casinoApi from 'api/casinoApi';
import { useAppTranslation } from 'app/hooks';
import HomeCasinoItem from 'features/casino/components/HomeCasinoItem';
import useUserDetail from 'hooks/useUserDetail';
import { AwcGame } from 'models/casino';
import React, { useEffect, useState } from 'react';
import minigame from 'assets/images/minigame.png';
import { Row } from 'antd';
import { Col } from 'antd';
import ConditionButton from 'components/Commons/ConditionButton';
import { IframeGame } from 'features/casino/components/HomeCasinoItem';

interface MiniGameProps {
  className?: string;
}

const MiniGame: React.FunctionComponent<MiniGameProps> = ({ className }) => {
  const { isUserLoggedIn, currentUser } = useUserDetail();
  const [game, setGame] = useState<AwcGame>();
  const [games, setGames] = useState<AwcGame[]>();

  const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

  const getFrame = async (game: AwcGame) => {
    const { ok, body } = await casinoApi.playGame({
      gameCode: game.gameCode,
      mobileLogin: false,
      provider: game.provider,
    });

    if (ok && body) {
      return body.url;
    }
    return undefined;
  };

  const retry = async (game: AwcGame, attempt = 1, maxRetries = 3) => {
    const result = await getFrame(game);
    if (!result && attempt < maxRetries) {
      await delay(2000);
      return await retry(game, attempt + 1, maxRetries);
    }
    return result;
  };

  const getGames = async () => {
    const { ok, body } = await casinoApi.getGame({
      size: 12,
      page: 0,
      sort: 'displayOrder,asc',
      ' platform.equals': '77GAMING',
      'isMiniGame.equals': true,
    });

    if (ok && body) {
      setGames(body);
    }
  };

  const handleSelectedGame = async (game: AwcGame) => {
    if (isUserLoggedIn) {
      const urlFrame = (await retry(game)) || '';
      setGame({ ...game, urlFrame: urlFrame });
    }
  };

  const handleCloseGame = () => {
    setGame(undefined);
  };

  useEffect(() => {
    getGames();
  }, [isUserLoggedIn, currentUser?.kyc?.status]);

  return (
    <div className={` minigame ${className}`}>
      {games && !game?.urlFrame ? (
        <Row className="relative" gutter={[16, 16]} wrap={true}>
          {games
            .sort((a, b) => a.order - b.order)
            .map((game) => (
              <Col
                key={game.gameCode}
                lg={{ span: 8 }}
                md={{ span: 8 }}
                sm={{ span: 12 }}
                xs={{ span: 12 }}
                className="casino-minigame-item"
              >
                <ConditionButton
                  className="play-button"
                  onClick={() => handleSelectedGame(game)}
                  content={
                    <div className="casino-minigame-image">
                      <img
                        onError={(e) => {
                          e.currentTarget.src = '/no_image.png';
                        }}
                        src={game.image}
                        alt="preview"
                      />
                    </div>
                  }
                  testerCheck={true}
                />
              </Col>
            ))}
        </Row>
      ) : (
        <div className="casino-iframe">
          {game && (
            <IframeGame
              title={game.name}
              gameUrl={game.urlFrame}
              gameCode={game.gameCode}
              provider={game.provider}
              handleClose={handleCloseGame}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default MiniGame;
